import { createRef, useLayoutEffect, useState } from 'react';
export var useRefs = function (_a) {
    var listToRender = _a.listToRender;
    var _b = useState([]), refs = _b[0], setRefs = _b[1];
    useLayoutEffect(function () {
        setRefs(function (prevRefs) {
            return Array(listToRender.length)
                .fill(null)
                .map(function (_, i) { return prevRefs[i] || createRef(); });
        });
    }, [listToRender.length]);
    return refs;
};
